import React, { Component } from 'react'
import HelpIcon from 'material-ui/svg-icons/action/help'
import TextField from 'material-ui/TextField'
import { FormattedMessage } from 'react-intl'
import FlatButton from 'material-ui/FlatButton'
import ReactTooltip from 'react-tooltip'

import { DetailsName } from './styles'
import { checkJapanese, createMarkup, getToken } from '../../../lib'

class Details extends Component {
  state = {
    nameError: false,
    name:
      Object.keys(this.props.conferenceDetails).length >= 1
        ? this.props.conferenceDetails.name
        : '',
    description:
      Object.keys(this.props.conferenceDetails).length >= 1 &&
      this.props.conferenceDetails.description
        ? this.props.conferenceDetails.description
        : '',
    password:
      Object.keys(this.props.conferenceDetails).length >= 1 &&
      this.props.conferenceDetails.password
        ? this.props.conferenceDetails.password
        : ''
  }

  handleSubmit = e => {
    e.preventDefault()
    const {name, description, password} = this.state
    const token = getToken()
    const {selectConferenceId} = this.props
    if (name.length === 0) {
      return this.setState({nameError: true})
    }
    this.props.updateConferenceDetails(
      token,
      selectConferenceId,
      name,
      description,
      password
    )
  }

  handleClearData = e => {
    e.preventDefault()
    this.setState({
      name: '',
      description: '',
      password: ''
    })
  }

  handleChange = (e, purpose) => {
    if (purpose === 'name') {
      this.setState({name: e.target.value, clear: false})
    } else if (purpose === 'description') {
      this.setState({description: e.target.value, clear: false})
    } else if (purpose === 'password') {
      this.setState({password: e.target.value, clear: false})
    }
  }

  render () {
    const {name, description, password, nameError} = this.state
    return (
      <form onSubmit={this.handleSubmit}>
        <ReactTooltip place="left" multiline effect="solid" html/>
        <div
          className={`flex w-100 items-center ${this.props.guest
            ? 'mb4'
            : 'mb2'}`}
        >
          <div className="w-10">
            <HelpIcon
              data-tip={`
              <div
                class='pb2 custom-tooltip'>
                ${this.props.guest
                ? checkJapanese() ? 'セミナーの名前' : 'Seminar Name'
                : checkJapanese()
                  ? 'セミナーの名前を\n入力してください。\n例えば、\n"マーケティング"'
                  : 'The name of this seminar. For example, input "martketing seminar"'}
              </div>`}
              color="#DDDDDD"
            />
          </div>
          <DetailsName className="w-90 pr2">
            {this.props.guest ? (
              <div style={{color: '#6B7C93'}}>
                {this.props.conferenceDetails.name}
              </div>
            ) : (
              <TextField
                inputStyle={{color: '#6B7C93'}}
                floatingLabelText={
                  <FormattedMessage id="seminarActions.name"/>
                }
                fullWidth
                hintText={<FormattedMessage id="seminarActions.name"/>}
                ref="name"
                errorText={nameError ? 'This field is required' : null}
                onChange={e => this.handleChange(e, 'name')}
                defaultValue={name || null}
              />
            )}
          </DetailsName>
        </div>
        <div className="flex w-100 mb3">
          <div className={!this.props.guest ? 'w-10 pt4' : 'w-10'}>
            <HelpIcon
              data-tip={`
              <div
                class='pb2 custom-tooltip'>
                ${this.props.guest
                ? checkJapanese()
                  ? 'セミナーの名前を\n入力してください。\n例えば、\n"マーケティング"'
                  : 'Seminar Description'
                : checkJapanese()
                  ? 'セミナーに関する情報を\n詳細に入力してください。'
                  : 'The description of this seminar. For example, input "the new way of selling our Product"'}
              </div>`}
              color="#DDDDDD"
            />
          </div>
          <DetailsName className="w-90 pr2">
            {this.props.guest ? (
              <div style={{color: '#6B7C93'}}>
                {description.length >= 1 ? (
                  <div style={{height: '50vh', overflow: 'auto'}}>
                    <div dangerouslySetInnerHTML={createMarkup(description)}/>
                  </div>
                ) : (
                  <FormattedMessage id="seminarActions.noDescription"/>
                )}
              </div>
            ) : (
              <TextField
                textareaStyle={{color: '#6B7C93', height: 250}}
                fullWidth
                floatingLabelText={
                  <FormattedMessage id="seminarActions.description"/>
                }
                multiLine={true}
                rows={20}
                style={{maxHeight: 300}}
                ref="description"
                hintText={<FormattedMessage id="seminarActions.description"/>}
                onChange={e => this.handleChange(e, 'description')}
                defaultValue={description || null}
              />
            )}
          </DetailsName>
        </div>
        {!this.props.guest && false ? (
          <div className="flex w-100 items-center mb3">
            <div className="w-10 flex flex-column justify-between">
              <HelpIcon
                data-tip={`
                <div
                  class='pb2 custom-tooltip'>
                  ${checkJapanese()
                  ? 'The password of protecting the seminar. If you set this, users have to input the correct password before joining in the seminar.'
                  : 'The password of protecting the seminar. If you set this, users have to input the correct password before joining in the seminar.'}

                </div>`}
                color="#DDDDDD"
              />
            </div>
            <DetailsName>
              <TextField
                inputStyle={{color: '#6B7C93'}}
                fullWidth
                floatingLabelText={
                  <FormattedMessage id="seminarActions.addPassword"/>
                }
                hintText={<FormattedMessage id="seminarActions.addPassword"/>}
                ref="description"
                onChange={e => this.handleChange(e, 'password')}
                value={password}
              />
            </DetailsName>
          </div>
        ) : (
          ''
        )}
        {!this.props.guest ? (
          <div className="flex justify-end">
            <div className="w4">
              <FlatButton
                onTouchTap={this.handleClearData}
                label={<FormattedMessage id="seminarActions.clear"/>}
                fullWidth
              />
            </div>
            <div className="ml2 w4">
              <FlatButton
                type="submit"
                fullWidth
                hoverColor="#52b98a"
                backgroundColor="#45CE90"
                labelStyle={{color: '#FFFFFF'}}
              >
                <span className="white">
                  <FormattedMessage id="seminarActions.saveDetails"/>
                </span>
              </FlatButton>
            </div>
          </div>
        ) : (
          ''
        )}
      </form>
    )
  }
}

export default Details



// WEBPACK FOOTER //
// ./src/components/Seminars/SeminarActions/Details.js